import { useEffect, useState } from 'react';
import { Api } from '../../componentes/Api';
import { Card, Col, Row, CardBody, CardHeader, CardTitle, FormText, Button, Modal, ModalHeader, ModalBody, Label, Input, FormGroup, ModalFooter } from "reactstrap"
import DataTable from 'react-data-table-component';
import Swal from 'sweetalert2';
import sucursal from "./Sucursal";
import Moment from "moment";
import Sucursal from './Sucursal';

const modeloDatos = {
    empresaID: 0,
    siglas: "",
    descripcion: "",
    rnc: "",
    telefono: 1,
    direccion: "",
    email: "",
    creadoPor: "",
    modificadoPor: "",
    fechaCreado: new Date,
    fechaModificado: new Date,
    estatus: true,
    logo: "",
    noWhatsapp: "",
    tokenWhatsapp: "",
    plantillaWhatsapp: "",
    facebook: "",
    instagrams: "",
    fechaL: new Date,


}
 
const Empresas = () => {
    const [tabla, setTabla] = useState(modeloDatos);
    const [Listado, SetListado] = useState([]);
    const [pendiente, setPendiente] = useState(true);
    const [verModal, setVerModal] = useState(false);
    const [verModalFoto, setverModalFoto] = useState(false);
    const [Controlfecha, setControlfecha] = useState();
    const [user, setUser] = useState(window.localStorage.getItem("sesion_usuario"))
    const [imageSrc, setImageSrc] = useState("");
    const [file, setFile] = useState(null);

    useEffect(() => {
        obtenerDatos();
        tabla.empresaID = JSON.parse(user).empresaID;
    }, [])


    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    };

    const handleUpload = async () => {
        if (!file) return;

        const formData = new FormData();
        formData.append("image", file);

        const response = await fetch(Api + "Administracion/UploadImage/"+ tabla.empresaID, {
            method: "POST",
            body: formData,
        });

        const data = await response.json();
        fetchImage1();
     
        setFile(null)
        console.log("Respuesta:", data);
    };
    const fetchImage1 = async () => {
        const response = await fetch(Api + "Administracion/MostraFoto/" + tabla.empresaID);
        const blob = await response.blob();
        setImageSrc(URL.createObjectURL(blob));
    };


    useEffect(() => {
        const fetchImage = async () => {
            const response = await fetch(Api + "Administracion/MostraFoto/" + tabla.empresaID);
            const blob = await response.blob();
            setImageSrc(URL.createObjectURL(blob));
        };

        fetchImage();
    }, [tabla.empresaID]);


    const handleChange = (e) => {
        let value = e.target.nodeName === "SELECT" ? (e.target.value == "true" ? true : false) : e.target.value;
        setTabla({
            ...tabla,
            [e.target.name]: value
        })
    }

    const obtenerDatos = async () => {
        let response = await fetch(Api + "Administracion/listaEmpresas/" + JSON.parse(user).idUsuario);
        if (response.ok) {
            let data = await response.json()
            SetListado(data)
            setPendiente(false)



        }
    }

 

    const mostrarMensaje = () => {
        Swal.fire({
            title: 'ERROR',
            text: "No puedes guardar si hay un elemento Activo.  Favor inactivar el elemento. ",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            //confirmButtonText: 'Si, continuar',
            cancelButtonText: 'volver'
        }).then((result) => {
            //alert(result.value)
            if (result.value) {


            }
        })

    }


    const guardarCambios = async () => {
        let response;
        if (tabla.especialistaID == 0) {
            tabla.creadoPor = JSON.parse(user).correo;
            response = await fetch(Api + "Administracion/GuardarEmpresas", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tabla)
            })
            setVerModal(!verModal);
        } else {
            tabla.modificadoPor = JSON.parse(user).correo;
            response = await fetch(Api + "Administracion/EditarEmpresas", {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tabla)
            })
        }

        if (response.ok) {

            if (tabla.activa == false) {
                setTabla(modeloDatos);
                setVerModal(!verModal);
            }
            let data1 = await response.json()

            if (data1 == false) {
                mostrarMensaje()
            } else {
                await obtenerDatos();
                setTabla(modeloDatos)
                setVerModal(!verModal);
            }
        } else {
            alert("error al guardar")
        }

    }

    const eliminarDatos = async (id) => {

        Swal.fire({
            title: 'Esta seguro?',
            text: "Desea eliminar el producto",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, continuar',
            cancelButtonText: 'No, volver'
        }).then((result) => {
            if (result.value) {
                const response = fetch(Api + "Citas/EliminarEspecialistas/" + id, { method: "DELETE" })
                    .then(response => {
                        if (response.ok) {
                            obtenerDatos();
                            Swal.fire(
                                'Eliminado!',
                                'El producto fue eliminado.',
                                'success'
                            )
                        }
                    })
            }
        })
    }

    const abrirEditarModal = (data) => {
        setTabla(data);
        setVerModal(!verModal);
    }
    const cerrarModal = () => {
        setTabla(modeloDatos)
        setVerModal(false)
        setverModalFoto(false)
    }

    const columns = [
        {
            name: 'ID',
            selector: row => row.empresaID,
            sortable: true,
        },
        {
            name: 'Texto ',
            selector: row => row.descripcion,
            sortable: true,
        },


        {
            name: 'Estatus',
            selector: row => row.estatus,
            sortable: true,
            cell: row => {
                let clase;
                clase = row.estatus ? "badge badge-info p-2" : "badge badge-danger p-2"
                return (
                    <span className={clase}>{row.estatus ? "Activo" : "No Activo"}</span>
                )
            }
        },
        {
            name: '',
            cell: row => (
                <>
                    <Button color="primary" size="sm" className="mr-2"
                        onClick={() => abrirEditarModal(row)}
                    >
                        <i className="fas fa-pen-alt"></i>
                    </Button>

                    <Button color="primary" size="sm" className="mr-2"
                        onClick={() => (setverModalFoto(true), tabla.empresaID= row.empresaID)} title="Cambiar Foto"
                    >
                        <i className="fas fa-images"></i>
                    </Button>


                </>
            ),
        },
    ];

    const customStyles = {
        headCells: {
            style: {
                fontSize: '13px',
                fontWeight: 800,
            },
        },
        headRow: {
            style: {
                backgroundColor: "#eee",
            }
        }
    };

    const paginationComponentOptions = {
        rowsPerPageText: 'Filas por página',
        rangeSeparatorText: 'de',
        selectAllRowsItem: true,
        selectAllRowsItemText: 'Todos',
    };

    return (
        <>
            <Card>
                <CardHeader style={{ backgroundColor: '#4e73df', color: "white" }}>
                    Lista de Empresas
                </CardHeader>
                <CardBody>
                    {(JSON.parse(user).idUsuario == 1) && <Button color="success" size="sm"
                        onClick={() => setVerModal(!verModal)}
                    >Nueva Empresa</Button>}
                    <hr></hr>
                    <DataTable
                        columns={columns}
                        data={Listado}
                        progressPending={pendiente}
                        pagination
                        paginationComponentOptions={paginationComponentOptions}
                        customStyles={customStyles}
                        expandableRows
                        expandableRowsComponent={Sucursal}
                    />
                </CardBody>
            </Card>

            <Modal isOpen={verModal} className="modal-preguntas">
                <ModalHeader className="modal-header1" togle>
                    <div class="box">
                        <div>   Mantenimiento de Empresas</div>
                        <div> <a className="btn" onClick={cerrarModal}>X</a> </div>
                    </div>
                   
                </ModalHeader>
                <ModalBody>
                    {/*<Row>*/}
                    {/*    <Col sm={12}>*/}
                    {/*        <FormGroup>*/}
                    {/*            <Label>Descripcion </Label>*/}
                    {/*            <Input  bsSize="sm" name="descripcion" onChange={handleChange} value={tabla.descripcion} />*/}
                    {/*        </FormGroup>*/}
                    {/*    </Col>*/}
                    
                    {/*</Row>*/}

                    {/*<Row>*/}
                    {/*    <Col sm={6}>*/}
                    {/*        <FormGroup>*/}
                    {/*            <Label>RNC</Label>*/}
                    {/*            <Input  bsSize="sm" name="rnc" onChange={handleChange} value={tabla.rnc} />*/}

                    {/*        </FormGroup>*/}
                    {/*    </Col>*/}
                    {/*    <Col sm={6}>*/}
                    {/*        <FormGroup>*/}
                    {/*            <Label>Siglas</Label>*/}
                    {/*            <Input bsSize="sm" name="siglas" onChange={handleChange} value={tabla.siglas} />*/}

                    {/*        </FormGroup>*/}
                    {/*    </Col>*/}

                    {/*    <Col sm={6}>*/}
                    {/*        <FormGroup>*/}
                    {/*            <Label>Telefono</Label>*/}
                    {/*            <Input  bsSize="sm" name="telefono" onChange={handleChange} value={tabla.telefono} />*/}

                    {/*        </FormGroup>*/}
                    {/*    </Col>*/}
                    {/*    <Col sm={6}>*/}
                    {/*        <FormGroup>*/}
                    {/*            <Label>Email</Label>*/}
                    {/*            <Input bsSize="sm" name="email" onChange={handleChange} value={tabla.email} />*/}

                    {/*        </FormGroup>*/}
                    {/*    </Col>*/}
                    {/*</Row>*/}

                    {/*<Row>*/}
                    {/*    <Col sm={12}>*/}
                    {/*        <FormGroup>*/}
                    {/*            <Label>Direccion</Label>*/}
                    {/*            <Input type="textarea" bsSize="sm" name="direccion" onChange={handleChange} value={tabla.direccion} />*/}

                    {/*        </FormGroup>*/}
                    {/*    </Col>*/}
                       
                    {/*</Row>     <Row>*/}
                    {/*    <Col sm={12}>*/}
                    {/*        <div>*/}
                    {/*            <input type="file" onChange={handleFileChange} />*/}
                    {/*            <button onClick={handleUpload}>Subir Imagen</button>*/}
                    {/*        </div>*/}

                    {/*        <div >*/}
                    {/*            {imageSrc && <img src={imageSrc} alt="Imagen desde la BD" width="300" />}*/}
                    {/*        </div>*/}

                    {/*    </Col>*/}
                       
                    {/*</Row>*/}

                    {/*<Row>*/}
                    {/*    <Col sm={6}>*/}
                    {/*        <FormGroup>*/}
                    {/*            <Label>No WhatsApp (META)</Label>*/}
                    {/*            <Input bsSize="sm" name="noWhatsapp" onChange={handleChange} value={tabla.noWhatsapp} />*/}

                    {/*        </FormGroup>*/}
                    {/*    </Col>*/}
                    {/*    <Col sm={6}>*/}
                    {/*        <FormGroup>*/}
                    {/*            <Label>Plantilla Whatsapp</Label>*/}
                    {/*            <Input bsSize="sm" name="plantillaWhatsapp" onChange={handleChange} value={tabla.plantillaWhatsapp} />*/}

                    {/*        </FormGroup>*/}
                    {/*    </Col>*/}
                      
                    {/*</Row>*/}

                    {/*<FormGroup>*/}
                    {/*    <Label>Token Whatsapp </Label>*/}
                    {/*    <Input bsSize="sm" type="textarea" name="tokenWhatsapp" onChange={handleChange} value={tabla.tokenWhatsapp} />*/}
                    {/*</FormGroup>*/}

                    {/*<Row>*/}
                    {/*    <Col sm={4}>*/}
                    {/*        <FormGroup>*/}
                    {/*            <Label>Estatus</Label>*/}

                    {/*            <Input bsSize="sm" type={"select"} name="estatus" onChange={handleChange} value={tabla.estatus} >*/}
                    {/*                <option value={true}>Activo</option>*/}
                    {/*                <option value={false}>No </option>*/}
                    {/*            </Input>*/}
                    {/*        </FormGroup>*/}
                    {/*    </Col>*/}

                       
                    {/*</Row>*/}

                    <div className="p-3">
                        <Card className="mb-4 shadow-sm rounded-3">
                            <CardBody>
                                <CardTitle tag="h5">Información General</CardTitle>
                                <Row className="mb-3">
                                    <Col sm={6}>
                                        <FormGroup>
                                            <Label>Descripción</Label>
                                            <Input bsSize="sm" name="descripcion" onChange={handleChange} value={tabla.descripcion} />
                                        </FormGroup>
                                    </Col>
                                    <Col sm={3}>
                                        <FormGroup>
                                            <Label>RNC</Label>
                                            <Input bsSize="sm" name="rnc" onChange={handleChange} value={tabla.rnc} />
                                        </FormGroup>
                                    </Col>
                                    <Col sm={3}>
                                        <FormGroup>
                                            <Label>Siglas</Label>
                                            <Input bsSize="sm" name="siglas" onChange={handleChange} value={tabla.siglas} />
                                        </FormGroup>
                                    </Col>
                                    <Col sm={3}>
                                        <FormGroup>
                                            <Label>Teléfono</Label>
                                            <Input bsSize="sm" name="telefono" onChange={handleChange} value={tabla.telefono} />
                                        </FormGroup>
                                    </Col>
                                    <Col sm={3}>
                                        <FormGroup>
                                            <Label>Email</Label>
                                            <Input bsSize="sm" name="email" onChange={handleChange} value={tabla.email} />
                                        </FormGroup>
                                    </Col>  <Col sm={3}>
                                        <FormGroup>
                                            <Label>Facebook</Label>
                                            <Input bsSize="sm" name="facebook" onChange={handleChange} value={tabla.facebook} />
                                        </FormGroup>
                                    </Col>  <Col sm={3}>
                                        <FormGroup>
                                            <Label>Instagrams</Label>
                                            <Input bsSize="sm" name="instagrams" onChange={handleChange} value={tabla.instagrams} />
                                        </FormGroup>
                                    </Col>
                                    <Col sm={12}>
                                        <FormGroup>
                                            <Label>Dirección</Label>
                                            <Input type="textarea" bsSize="sm" name="direccion" onChange={handleChange} value={tabla.direccion} />
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>

                       

                        <Card className="mb-4 shadow-sm rounded-3">
                            <CardBody>
                                <CardTitle tag="h5">Otro</CardTitle>
                                <Row>
                                    <Col sm={3}>
                                        <FormGroup>
                                            <Label>No. WhatsApp</Label>
                                            <Input bsSize="sm" name="noWhatsapp" onChange={handleChange} value={tabla.noWhatsapp} />
                                        </FormGroup>
                                    </Col>
                                    <Col sm={3}>
                                        <FormGroup>
                                            <Label>EXC</Label>
                                            <Input bsSize="sm" name="plantillaWhatsapp" onChange={handleChange} value={tabla.plantillaWhatsapp} />
                                        </FormGroup>
                                    </Col>
                                    <Col sm={6}>
                                <FormGroup>
                                    <Label>Token WhatsApp / Especialidad</Label>
                                    <Input type="textarea" bsSize="sm" name="tokenWhatsapp" onChange={handleChange} value={tabla.tokenWhatsapp} />
                                        </FormGroup>     </Col>   </Row>
                            </CardBody>
                        </Card>
{tabla.itbisIncluido}
                        {(tabla.empresaID != 0) && <Card className="mb-4 shadow-sm rounded-3">
                            <CardBody>
                                <CardTitle tag="h5">Estado</CardTitle>
                         {(JSON.parse(user).idUsuario == 1) &&         <Row>
                                    <Col sm={4}>
                                        <FormGroup>
                                            <Label>ITBIS INCLUIDO</Label>
                                            <Input type="select" bsSize="sm" name="itbisIncluido" onChange={handleChange} value={tabla.itbisIncluido}>
                                                <option value={true}>Si</option>
                                                <option value={false}>No</option>
                                            </Input>
                                        </FormGroup>
                                    </Col>

                                  
                                      <Col sm={4}>
                                        <FormGroup>
                                            <Label>Estatus</Label>
                                            <Input type="select" bsSize="sm" name="estatus" onChange={handleChange} value={tabla.estatus}>
                                                <option value={true}>Activo</option>
                                                <option value={false}>No</option>
                                            </Input>
                                        </FormGroup>
                                    </Col>
                                        <Col sm={4}>
                                            <FormGroup>
                                                <label for="fechaNacimiento">Fecha L</label>
                                                <input type="date" id="fechaL" name="fechaL" value={Moment(tabla.fechaL).format('YYYY-MM-DD')}
                                                  onChange={handleChange} />
                                            </FormGroup>
                                        </Col>  
                                  
                                </Row>}
                            </CardBody>
                        </Card>}
                  
                    </div>

                </ModalBody>
                <ModalFooter>
                    <div > <Button size="sm" color="primary"
                        onClick={guardarCambios}
                    >Guardar</Button></div>
                    <Button size="sm" color="danger"
                        onClick={cerrarModal}
                    >Cerrar</Button>
                </ModalFooter>
            </Modal>

            <Modal isOpen={verModalFoto} className="modal-preguntas">
                <ModalHeader className="modal-header1">
                    <div class="box">
                        <div>   Lista de articulos diponible en el almacen </div>
                        <div><a className="btn" style={{ color: "#ffff" }} onClick={cerrarModal}>X</a></div>
                    </div>
                </ModalHeader>
                <ModalBody>
                    <Row>
                        <CardBody>
                            <CardTitle tag="h5">Imagen de la Empresa</CardTitle>
                            <FormGroup>
                                <Label for="fileInput">Seleccionar Imagen</Label>
                                <Input type="file" id="fileInput" onChange={handleFileChange} />
                                <FormText color="muted">Formato recomendado: JPG o PNG. Tamaño máximo: 2MB.</FormText>

                                {(file != null) && <Button color="primary" size="sm" onClick={handleUpload}>Guardar</Button>}
                                {imageSrc && (
                                    <div className="mt-3">
                                        <img src={imageSrc} alt="Imagen cargada" width="200" className="rounded shadow-sm" />
                                    </div>
                                )}</FormGroup>
                        </CardBody>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Button size="sm" color="danger"
                        onClick={cerrarModal}
                    >Cerrar</Button>
                </ModalFooter>
            </Modal>

        </>
    )

}
export default Empresas;